module.exports = __webpack_public_path__ + "static/media/ridelightpro-1.37004b2e.jpg";